import { TFunction } from 'i18next'
import { QUERY_VALUES } from 'lib/util/routing'

enum SkillLevel {
  All = 'all',
  Beginner = 'beginner',
  Advanced = 'advanced',
}
export default SkillLevel

export function getDisplayNames(t: TFunction) {
  return {
    [SkillLevel.All]: t('home.skillLevels.allLong'),
    [SkillLevel.Beginner]: t('home.skillLevels.beginner'),
    [SkillLevel.Advanced]: t('home.skillLevels.advanced')
  }
}

const skillLevelByQueryValue = {
  [QUERY_VALUES.beginner]: SkillLevel.Beginner,
  [QUERY_VALUES.advanced]: SkillLevel.Advanced
}

export function getSkillLevelByQueryValue(queryValue: string): SkillLevel {
  return skillLevelByQueryValue[queryValue] || SkillLevel.All
}
